function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { createContext, useContext, useState, useEffect } from 'react';
import { colors, spacing, typography, shadows } from '../tokens';
import { jsx as _jsx } from "react/jsx-runtime";
var ThemeContext = /*#__PURE__*/createContext({
  theme: 'light',
  toggleTheme: function toggleTheme() {}
});
export function BafkalThemeProvider(_ref) {
  var children = _ref.children,
    _ref$initialMode = _ref.initialMode,
    initialMode = _ref$initialMode === void 0 ? 'light' : _ref$initialMode;
  var _useState = useState(initialMode),
    _useState2 = _slicedToArray(_useState, 2),
    theme = _useState2[0],
    setTheme = _useState2[1];
  useEffect(function () {
    var root = document.documentElement;
    root.style.setProperty('--bafkal-primary', colors.primary[600]);
    root.style.setProperty('--bafkal-bg-page', theme === 'dark' ? colors.neutral[900] : colors.neutral[50]);
    root.style.setProperty('--bafkal-bg-surface', theme === 'dark' ? colors.neutral[700] : '#ffffff');
    root.style.setProperty('--bafkal-text-main', theme === 'dark' ? colors.neutral[50] : colors.neutral[900]);
  }, [theme]);
  var toggleTheme = function toggleTheme() {
    return setTheme(function (prev) {
      return prev === 'light' ? 'dark' : 'light';
    });
  };
  return /*#__PURE__*/_jsx(ThemeContext.Provider, {
    value: {
      theme: theme,
      toggleTheme: toggleTheme
    },
    children: children
  });
}
export function useTheme() {
  return useContext(ThemeContext);
}